import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class HieroglyphWind extends PIXI.Container {
    private static readonly SPAWN_DELAY: PIXI.Point = new PIXI.Point(.05, .25);
    private static readonly SPAWN_RECT: PIXI.Rectangle = new PIXI.Rectangle(-300, -200, 300, 200);
    private static readonly ANIM_KEY: string = "Anim_Wind";

    private _pool: HLF.AnimatedSprite[];
    private _active: HLF.AnimatedSprite[];
    private _spawnTimer: number;
    private _spawnDelay: number;
    private _overlay: PIXI.Sprite;
    private _windContainer: PIXI.Container;

    constructor() {
        super();
        this._spawnTimer = 0;
        this._spawnDelay = HLF.Random.floatBetween(HieroglyphWind.SPAWN_DELAY.x, HieroglyphWind.SPAWN_DELAY.y);

        this._pool = new Array<HLF.AnimatedSprite>();
        this._active = new Array<HLF.AnimatedSprite>();

        this._windContainer = new PIXI.Container();
        this.addChild(this._windContainer);

        this._overlay = HLF.PixiUtils.makeSprite("empty-pixel", Constants.SPRITESHEET_UI);
        this._overlay.scale.set(702, 499);
        this._overlay.tint = 0xFFF8C1;
        this._overlay.alpha = 0.3;
        this.addChild(this._overlay);

        this.prepopulate();
    }

    public update(pDeltaTime: number): void {
        for (let i = 0; i < this._active.length; ++i) {
            this._active[i].update(pDeltaTime);
        }
        this._spawnTimer += pDeltaTime;
        while (this._spawnTimer >= this._spawnDelay) {
            this._spawnTimer -= this._spawnDelay;
            this._spawnDelay = HLF.Random.floatBetween(HieroglyphWind.SPAWN_DELAY.x, HieroglyphWind.SPAWN_DELAY.y);
            this.spawnWind();
            this._active[this._active.length - 1].update(this._spawnTimer);
        }
        for (let i = this._active.length - 1; i >= 0; --i) {
            if (this._active[i].isPlaying === false) {
                const wind: HLF.AnimatedSprite = this._active[i];
                this._active.splice(i, 1);
                this._windContainer.removeChild(wind);
                this._pool.push(wind);
            }
        }
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions): void {
        for (let i = 0; i < this._pool.length; ++i) {
            this._pool[i].destroy();
        }
        delete this._pool;
        for (let i = 0; i < this._active.length; ++i) {
            this._active[i].destroy();
        }
        delete this._active;
        super.destroy(pOptions);
    }

    private prepopulate(): void {
        this.update(3);
    }

    private spawnWind(): void {
        const wind: HLF.AnimatedSprite = this.getWindParticle();
        wind.position.set(
            HLF.Random.floatBetween(HieroglyphWind.SPAWN_RECT.x, HieroglyphWind.SPAWN_RECT.width),
            HLF.Random.floatBetween(HieroglyphWind.SPAWN_RECT.y, HieroglyphWind.SPAWN_RECT.height),
        );
        wind.scale.set(
            HLF.Random.floatBetween(0.7, 1),
            HLF.Random.floatBetween(0.7, 1) * (HLF.Random.bool() ? 1 : -1),
        );
        this._active.push(wind);
        this._windContainer.addChild(wind);
        wind.play(HieroglyphWind.ANIM_KEY);
    }

    private getWindParticle(): HLF.AnimatedSprite {
        let wind: HLF.AnimatedSprite;
        if (this._pool.length > 0) {
            wind = this._pool.pop()!;
        }
        else {
            wind = new HLF.AnimatedSprite();
            wind.addAnimation(HieroglyphWind.ANIM_KEY, new HLF.SpriteAnimation(
                "wind-", "hieroglyph-00", 8, 2, 10, false,
            ));
            wind.tint = 0xFFF7B6;
        }
        return wind;
    }
}
